import { h, Component } from 'preact';
import style from './style';

import FormRow from './form_row';

export default class Form extends Component {
	initializeFormResponses = () => {
		let responses = {};
		Object.keys(this.props.formStructure.fields).forEach((field) => {
			responses[field] = { value: '', validationErrors: []};
		});
		return responses;
	}
	state = { formResponses: this.initializeFormResponses(), submitted: false };
	runValidations = (fieldKey, value) => {
		let validationErrors = [];
		this.props.formStructure.fields[fieldKey].validations.forEach((item, index) => {
			switch(item.type) {
				case "required":
					if (value === "") {
						validationErrors.push(item);
					}
					break;
				case "dateinfuture":
					const dateValue = Date.parse(value);
					const nowDateTime = new Date();
					const nowDate = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate());
					if (nowDate > dateValue) {
						validationErrors.push(item);
					}
					break;
				case "regex":
					if(value === null || value === "") break;
					const pattern = new RegExp(item.pattern);
					const match = pattern.test(value);
					if (!match) {
						validationErrors.push(item);
					}
					break;
				case "maxLength":
					if(value === null || value === "") break;
					if (value.length > item.maxLength) {
						validationErrors.push(item);
					}
					break;
			}
		});
		return validationErrors;
	}
	validateAndStoreField = (fieldKey, newValue) => {
		const validationErrors = this.runValidations(fieldKey, newValue);
		let formResponses = this.state.formResponses;
		formResponses[fieldKey].value = newValue;
		formResponses[fieldKey].validationErrors = validationErrors;
		this.setState({formResponses: formResponses});
	}
	formJSONArgs = () => {
		let args = {};
		// Form identifying info
		args['formKey'] = this.props.formStructure.info.formKey;

		// Form response
		Object.keys(this.state.formResponses).forEach((fieldKey) => {
			args[fieldKey] = this.state.formResponses[fieldKey].value;
		});

		return args;
	}
	attemptSubmit = (e) => {
		e.preventDefault();
		this.setState({submitting: true});
		// check all fields for validations
		let responses = this.state.formResponses;
		Object.keys(this.props.formStructure.fields).forEach((fieldKey) => {
			responses[fieldKey].validationErrors = this.runValidations(fieldKey, responses[fieldKey].value);
		});
		// if any validation errors are present then stop
		const errorCount = Object.keys(responses).reduce((sum, response) => {
			return sum + responses[response].validationErrors.length;
		}, 0);
		if(errorCount === 0) {
			// submit that thing
			let body = this.formJSONArgs();
			const endpoint = this.props.formStructure.info.apiEndpoint;
			let result = fetch(`${endpoint}`, {
				method: 'POST',
				headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'appKey' : this.props.formStructure.info.appKey,
						'clientKey' : this.props.formStructure.info.clientKey,
						'formId' : this.props.formStructure.info.formId
				},
				body: JSON.stringify(body),
				credentials: 'include'})
			.then((response) => {
				if(this.props.formStructure.info.redirectUrl === '') {
					this.setState({submitted: true});
				} else {
					window.top.location = this.props.formStructure.info.redirectUrl;
				}
			});

		} else {
			// there were errors
			console.log("errors so not submitting");
			this.setState({submitting: false});
		}
		this.setState({formResponses: responses});
	}
	render({ formStructure, fieldTypeRenderer }, { }) {
		return (
			(this.state.submitted ?
				<div>{formStructure.info.submissionText}</div>
				:
			<form class="inquiryFormContainer" onSubmit={this.attemptSubmit}>
				{ formStructure.layout.rows.map( row => (
        	 		<FormRow row={row} validateAndStoreField={this.validateAndStoreField} responses={this.state.formResponses} submitting={this.state.submitting} fieldTypeRenderer={fieldTypeRenderer} />
        		)) }
      		</form>)
		);
	}
}



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/src/components/form/index.js